import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Text from '@/v2/components/atoms/Text';

import './Switch.scss';

const propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    labelClasses: PropTypes.string,
};
const defaultProps = {
    labelClasses: '',
};

const Switch = ({ onChange, label, labelClasses, ...props }) => {
    const classes = classnames({
        label: true,
        [`${labelClasses}`]: labelClasses !== '',
    });

    return (
        <div className="Switch" {...props}>
            <input type="checkbox" onChange={onChange} id="switch" />
            <label htmlFor="switch">
                <Text component="span" className={classes}>
                    {label}
                </Text>
            </label>
        </div>
    );
};

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;

export default Switch;
